const messages = {
    buttons: {
        productBrochures: "Discover",
    },
    index: {
        title: "PRODUCT INFORMATION",
        description: "Download here the latest brochures and flyers of our Bridgestone and Firestone tires.",
        categories: {
            productBrochures: {
                title: "Product brochures",
                description: "Brochures of Bridgestone and Firestone tire ranges",
            },
            bDrive: {
              title: "Product Images",
              description: "You can find current images for download in our B-DRIVE portal.",
            },
        
          kickback: {
            description: "Bonuses are granted to participating companies based on submitted sales figures.",
          },}
    }
};

export default {
    messages,
};

